import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as subawardPis from '../../subaward-pis'

export const RESOURCE = {
  payload: {
    description:
      'The association(s) between principal investigator (PI) and subaward. A PI may oversee multiple subawards or share a subaward with other PIs.',
    dimension: subawardPis.RESOURCE.payload,
    level: 0,
    name: 'Subaward PI',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
